// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"rv-z","categoryName":"sv-z","categoryImage":"tv-z","categoryContent":"uv-z","bottomAligned":"vv-z"};